import { PageHeader } from "@/pages/layoutChrome";
import ModuleClientSelector from "@/components/ModuleClientSelector";
import { TramitesEmbeddedPanel } from "@/modules/tramites/embeddedPanels";
import { TRAMITES_CONTEXT_LABEL, TRAMITES_TAB_IDS } from "@/modules/tramites/manifest";

/**
 * Pantalla Trámites — Inscripción trabajadores IMSS (permanece en módulo Trámites Fiscales).
 */
export default function TramitesInscripcionTrabajadoresImss() {
  return (
    <div className="space-y-6" data-testid="tramites-inscripcion-trabajadores-imss-page">
      <PageHeader
        title="Inscripción de trabajadores IMSS"
        subtitle="Prepare y controle trámites de inscripción de trabajadores ante IMSS desde Trámites Fiscales. No abre el módulo Laboral/REPSE."
        breadcrumb={[TRAMITES_CONTEXT_LABEL, "Inscripción de trabajadores IMSS"]}
      />

      <div className="px-8 max-w-6xl">
        <ModuleClientSelector variant="panel" className="mb-6" />
        <TramitesEmbeddedPanel tabId={TRAMITES_TAB_IDS.INSCRIPCION_IMSS} />
      </div>
    </div>
  );
}
